import "./App.css";

import { BrowserRouter as Router, Switch, Route } from "react-router-dom";

/* Views */
import HomePage from "views/HomePage/HomePage";
import CategorySection from "views/CategorySection/CategorySection";
import Ventas from "views/Administrador/Ventas/Ventas";
import Registro from "views/Registros/Registro";
import AdminLogin from "views/AdminLogin/AdminLogin";
import PanelAdministracion from "views/PanelAdministracion/PanelAdministracion";
import EnviosyPagos from "views/EnviosyPagos/EnviosyPagos";
import Nosotros from "views/Nosotros/Nosotros";
import Contacto from "views/Contacto/Contacto";
import Tips from "views/Tips/Tips";
import TipsRegistro from "views/Tips/TipsRegistro";
import TipsOrdenar from "views/Tips/TipsOrdenar";
import BannersOrdenar from "views/Banners/BannersOrdenar";
import TipsEditar from "views/Tips/TipsEditar";

/* Components */
import SearchBar from "components/SearchBar/SearchBar";
import ContactBar from "components/ContactBar/ContactBar";
import Footer from "components/Footer/Footer";
import Producto from "./views/Productos/Producto.js";
import AvisoDePrivacidad from "views/AvisoDePrivacidad/AvisoDePrivacidad";
import PaginaEnServicio from "components/PaginaEnServicio/PaginaEnServicio";
import FilterSearchProducts from "views/FilterSeachProducts/FilterSearchProducts";
import Paper from "views/Paper/Paper";

import { ThemeProvider, createTheme } from "@mui/material/styles";
import LoginUser from "components/SiginUser/SigininUser";
import Register from "components/SiginUser/Register";
import Profile from "components/SiginUser/Profile";
import TerminosYCondiciones from "views/TerminosYCondiciones/TerminosYCondiciones";
import PoliticasDeCompra from "views/PoliticasDeCompra/PoliticasDeCompra";
import { Box } from "@mui/material";
import WhatsAppButton from "components/WhatsappButton/WhatsappButton";
import { Redirect } from "react-router-dom/cjs/react-router-dom.min";
import Descuentos from "views/Descuentos/Descuentos";
import PublicadorMasivo from "views/PublicadorMasivo/PublicadorMasivo";
import NewProducto from "views/NewProducto/NewProducto";
import NewCarritoDeCompra from "views/NewCarritoDeCompra/NewCarritoDeCompra";
import OilProduct from "views/CategorySection/Oil/OilProduct";
import { createOrder } from "utils/LaravelApi/LaravelAPI";
import { sendClientEmail } from "utils/EmailSender/EmailSender";
import Pedido from "views/Pedido/Pedido";

const theme = createTheme({
  palette: {
    primary: {
      main: "#E21608",
    },
    secondary: {
      main: "#BC0900",
    },
    back: {
      main: "rgb(0,0,0)",
    },
  },
});

function App() {
  return (
    <ThemeProvider theme={theme}>
      <div className="App">
        
        {/*
        <button onClick={async () => {
          const data = {
            "realDate": "2025-05-23T16:21:56.146Z",
            "date": "23-05-2025 10:21",
            "name": "Luis Erick",
            "email": "lemg040798@gmail.com",
            "street": "Cto Merlot",
            "postalCode": "38115",
            "colony": "Viñedos",
            "city": "Celaya",
            "state": "Guanajuato",
            "phone": "4612803113",
            "referenceAddress": "ok",
            "status": "En preparación",
            "products": [
              {
                "quantity": 1,
                "name": "KIT DE FILTROS PARA AFINACIÓN TRANSMISIÓN CVT PARA NISSAN ALTIMA 2007-2012 3.5L AFINAZONE",
                "category": "kit-de-afinacion",
                "id": 1,
                "price": 849.99
              }
            ],
            "metodo_pago": "paypal"

          };
          const createOrderResponse = await createOrder(data);
          const clientData = {
            ...data,
            reference: data.referenceAddress,
            neighbor: data.colony,
            postal_code: data.postalCode,
            country: `${window.location.origin}/pedido/${createOrderResponse?.data?.order?.uuid}`,
            pedido: createOrderResponse?.data?.order?.id,
          };
          const emailStatus = await sendClientEmail(clientData, data.products);
        }}>
          Test
        </button>
        */}
        
        <Router>
          {/* A <Switch> looks through its children <Route>s and
          renders the first one that matches the current URL. */}
          <WhatsAppButton />
          <SearchBar />
          <Box sx={{ display: { xs: "none", sm: "block" } }}>
            <ContactBar />
          </Box>
          <Switch>
            <Route path="/PaginaEnServicio">
              <PaginaEnServicio />
            </Route>
            <Route path="/AvisoDePrivacidad">
              <AvisoDePrivacidad />
            </Route>
            <Route path="/TerminosYCondiciones">
              <TerminosYCondiciones />
            </Route>
            <Route path="/PoliticasDeCompra">
              <PoliticasDeCompra />
            </Route>
            <Route path="/Categoria/:typeSlug">
              <CategorySection />
            </Route>
            <Route path="/Registro">
              <Registro />
            </Route>
            <Route exact path="/">
              <Redirect to="/refacciones-kits-afinacion-transmision" />
            </Route>
            <Route exact path="/refacciones-kits-afinacion-transmision">
              <HomePage />
            </Route>
            <Route exact path="/Ventas">
              <Ventas />
            </Route>
            <Route exact path="/Producto">
              <Producto />
            </Route>
            <Route exact path="/Producto/:category/:name">
              <NewProducto />
            </Route>
            <Route path={"/OilProduct/:type/:brand/:characteristic/:unit"}>
              <OilProduct />
            </Route>
            <Route path="/pedido/:uuid">
              <Pedido />
            </Route>
            <Route exact path="/Carrito">
              <NewCarritoDeCompra />
            </Route>
            <Route exact path="/Login">
              <AdminLogin />
            </Route>
            <Route exact path="/LoginUser">
              <LoginUser />
            </Route>
            <Route exact path="/RegisterUser">
              <Register />
            </Route>
            <Route exact path="/Profile">
              <Profile />
            </Route>
            <Route exact path="/PanelAdministracion">
              <PanelAdministracion />
            </Route>
            <Route exact path="/envios-y-pagos">
              <EnviosyPagos />
            </Route>
            <Route exact path="/conoce-afinazone">
              <Nosotros />
            </Route>
            <Route exact path="/contacto-afinazone">
              <Contacto />
            </Route>
            <Route exact path="/tips-mantenimiento-auto">
              <Tips />
            </Route>
            <Route exact path="/TipsRegistro">
              <TipsRegistro />
            </Route>
            <Route exact path="/OrdenarTips">
              <TipsOrdenar />
            </Route>
            <Route exact path="/OrdenarBanners">
              <BannersOrdenar />
            </Route>
            <Route exact path="/Busqueda">
              <FilterSearchProducts />
            </Route>
            <Route exact path="/TipsEditar">
              <TipsEditar />
            </Route>
            <Route exact path="/Paper">
              <Paper />
            </Route>
            <Route exact path="/Descuentos">
              <Descuentos />
            </Route>
            <Route exact path="/PublicadorMasivo">
              <PublicadorMasivo />
            </Route>
          </Switch>
          <Footer />
        </Router>
      </div>
    </ThemeProvider >
  );
}

export default App;
